import React from 'react';
import ReactSVG from 'react-svg';
import default_icon from 'default_icon.svg';

export default function NoResults() {
  return (
    <div className="no-results">
      <ReactSVG src={default_icon} />
      <h2>Oops! No results found.</h2>
      <p>Try moving the map or use more general search filters.</p>
    </div>
  );
}
